var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "@madmedical/i18n";
import Button from "../../atoms/Button";
import CallCenterDeviceList from "../../organisms/CallCenter/CallCenterDeviceList";
import Headline from "../../molecules/Headline";
import Paper from "../../atoms/Paper";
const CallCenterDevices = (_a) => {
    var { onAddPress } = _a, props = __rest(_a, ["onAddPress"]);
    const { t } = useTranslation();
    return (_jsxs(Paper, { children: [_jsx(Headline, { size: "lg", title: t("devices"), rightContent: _jsx(Button, Object.assign({ leftIconName: "add", variant: "outlined", onPress: onAddPress }, { children: t("newDevice") })) }), _jsx(CallCenterDeviceList, Object.assign({}, props))] }));
};
export default CallCenterDevices;
